export default __webpack_public_path__ + "static/media/ttb.29440cab.svg";